<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
// components
import SiteFooterContainer from '@Widgets/Footers/SiteFooterContainer.vue'
// async components
const FooterLegacy = defineAsyncComponent(() => import('@Widgets/Footers/FooterLegacy.vue'))

defineOptions({
  name: 'TheFooter',
})

// The redesigned footer (GRWT-187) rolls out site-wide, while /help-center and
// /help-center/* keep the legacy footer until the help-center redesign lands.
// Route-based (not layout-based): help-center pages are split across both layouts.
const route = useRoute()

const refIsHelpCenter = computed<boolean>(() => route.path.startsWith('/help-center'))
</script>

<template>
  <FooterLegacy v-if="refIsHelpCenter" />
  <SiteFooterContainer v-else />
</template>
